import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';

import WorkspacePremiumTwoToneIcon from '@mui/icons-material/WorkspacePremiumTwoTone';
import React, { useState } from 'react';

const ModalComissaoProdutosVendedor = ({ onClose, dados, top10Produtos }) => {

    const { agrupador, projecao, projecaocomissao } = dados;
    const [valorSliderComissao, setValorSliderComissao] = useState(parseFloat(projecao));

    function handleSliderComissaoChange(newValue) {
        setValorSliderComissao(newValue);
    }

    function calcularComissaoSlider() {
        try {
            const comissao = (valorSliderComissao * projecaocomissao) / projecao;

            if (parseFloat(projecaocomissao) === 0) {
                return 'R$0,00'
            }

            return comissao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        } catch (error) {
            console.error('Erro: ' + error.message)
        }
    }

    function formatoMoeda(value) {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    }

    return (
        <div className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center z-10 overflow-auto">
            <div className="bg-white rounded-lg w-full max-w-3x1 md:max-w-6xl relative">
                <header className="bg-red-500 border-b-4 border-red-700 p-2">
                    <div className="flex items-center text-white">
                        <AutoGraphOutlinedIcon className="mr-2" />
                        <h1 className="text-xl font-bold">Aumente suas vendas</h1>
                    </div>
                    <button className="absolute top-2 right-2 text-white" onClick={onClose}>
                        &times;
                    </button>
                    <p className="text-sm mt-2 text-white text-left">Selecionamos alguns itens que podem ajudar a melhorar seus indicadores de venda!</p>
                </header>

                <div className="p-4 overflow-y-auto max-h-[26rem] md:max-h-[28rem]">
                    <div className="mt-2">
                        <label className="block text-gray-c21 text-lg mb-2 text-left">Simulador de Comissão: {agrupador}</label>
                        <div className="flex items-center">
                            <Slider
                                min={parseFloat(projecao)}
                                max={parseFloat(projecao) * 4}
                                step={15}
                                value={valorSliderComissao}
                                onChange={handleSliderComissaoChange}
                            />
                            <span className="text-gray-c21 ml-2 text-lg">{formatoMoeda(valorSliderComissao)}</span>
                        </div>
                        <p className="text-gray-c21 mt-2 text-lg text-left">{`Comissão Simulada:${calcularComissaoSlider()}`}</p>
                    </div>

                    <div className="mt-4">
                        <div className="overflow-x-auto">
                            {top10Produtos.length > 0 ? (
                                <table className="w-full border-collapse">
                                    <thead>
                                        <tr>
                                            <th className="border-b p-2">Posição</th>
                                            <th className="border-b p-2 coluna-departamento">Produto</th>
                                            <th className="border-b p-2">Preço</th>
                                            <th className="border-b p-2">Comissão S/Juros</th>
                                            <th className="border-b p-2">Comissão C/Juros</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {top10Produtos.map((item, index) => (
                                            <tr key={index} className="border-b">
                                                <td className="p-2">
                                                    {item.posicao}
                                                    {item.posicao === '1' && <WorkspacePremiumTwoToneIcon className="text-yellow-500 ml-2 inline" />}
                                                    {item.posicao === '2' && <WorkspacePremiumTwoToneIcon className="text-gray-500 ml-2" />}
                                                    {item.posicao === '3' && <WorkspacePremiumTwoToneIcon className="text-yellow-700 ml-2" />}
                                                </td>
                                                <td className="p-2 coluna-departamento">{item.descricao}</td>
                                                <td className="p-2">{formatoMoeda(item.precovenda)}</td>
                                                <td className="p-2">{formatoMoeda(item.comissaosemjuros)}</td>
                                                <td className="p-2">{formatoMoeda(item.comissaojuros)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>) 
                                : 
                                (
                                    <p className="text-lg mt-2 text-center">Sem dados no momento!</p>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalComissaoProdutosVendedor;